import { connect } from 'react-redux';
import { customerOuidSelector } from '../../modules/Customer/selectors';
import * as actions from '../../modules/VoucherAddMoney/actions';
import { voucherAmountSelector, voucherCodeSelector } from '../../modules/VoucherAddMoney/selectors';
import VoucherModal from './VoucherModal';

const mapStateToProps = state => ({
  code: voucherCodeSelector(state),
  customerOuid: customerOuidSelector(state),
  voucherPrice: voucherAmountSelector(state),
});

const mapDispatchToProps = {
  redeemVoucher: actions.redeemVoucher,
  leaveAddMoneyScene: actions.leaveAddMoneyScene,
};

export default connect(mapStateToProps, mapDispatchToProps)(VoucherModal);
